var map = {
	"./add-lg.svg": "./src/images/add-lg.svg",
	"./add.svg": "./src/images/add.svg",
	"./add_16x16.svg": "./src/images/add_16x16.svg",
	"./add_24x24.svg": "./src/images/add_24x24.svg",
	"./alert_24x24.svg": "./src/images/alert_24x24.svg",
	"./apply.svg": "./src/images/apply.svg",
	"./arrow-down.svg": "./src/images/arrow-down.svg",
	"./arrow-left.svg": "./src/images/arrow-left.svg",
	"./arrow-left_16x16.svg": "./src/images/arrow-left_16x16.svg",
	"./arrow-right.svg": "./src/images/arrow-right.svg",
	"./arrow-right_16x16.svg": "./src/images/arrow-right_16x16.svg",
	"./arrow-up.svg": "./src/images/arrow-up.svg",
	"./boolean.svg": "./src/images/boolean.svg",
	"./change-question-type_16x16.svg": "./src/images/change-question-type_16x16.svg",
	"./checkbox.svg": "./src/images/checkbox.svg",
	"./checked.svg": "./src/images/checked.svg",
	"./chevron_16x16.svg": "./src/images/chevron_16x16.svg",
	"./clear.svg": "./src/images/clear.svg",
	"./clear_16x16.svg": "./src/images/clear_16x16.svg",
	"./codeeditor-24x24.svg": "./src/images/codeeditor-24x24.svg",
	"./collapse-detail-light_16x16.svg": "./src/images/collapse-detail-light_16x16.svg",
	"./collapse-detail_16x16.svg": "./src/images/collapse-detail_16x16.svg",
	"./collapse-panel.svg": "./src/images/collapse-panel.svg",
	"./collapse-v_16x16.svg": "./src/images/collapse-v_16x16.svg",
	"./collapse_16x16.svg": "./src/images/collapse_16x16.svg",
	"./collapseall-24x24.svg": "./src/images/collapseall-24x24.svg",
	"./color-picker.svg": "./src/images/color-picker.svg",
	"./comment.svg": "./src/images/comment.svg",
	"./config.svg": "./src/images/config.svg",
	"./copy.svg": "./src/images/copy.svg",
	"./default.svg": "./src/images/default.svg",
	"./delete_16x16.svg": "./src/images/delete_16x16.svg",
	"./delete_24x24.svg": "./src/images/delete_24x24.svg",
	"./description-hide.svg": "./src/images/description-hide.svg",
	"./description.svg": "./src/images/description.svg",
	"./device-desktop.svg": "./src/images/device-desktop.svg",
	"./device-phone.svg": "./src/images/device-phone.svg",
	"./device-rotate.svg": "./src/images/device-rotate.svg",
	"./device-tablet.svg": "./src/images/device-tablet.svg",
	"./download.svg": "./src/images/download.svg",
	"./drag-area-indicator.svg": "./src/images/drag-area-indicator.svg",
	"./drag-area-indicator_24x16.svg": "./src/images/drag-area-indicator_24x16.svg",
	"./drop-down-arrow.svg": "./src/images/drop-down-arrow.svg",
	"./drop-down-arrow_16x16.svg": "./src/images/drop-down-arrow_16x16.svg",
	"./dropdown.svg": "./src/images/dropdown.svg",
	"./duplicate_16x16.svg": "./src/images/duplicate_16x16.svg",
	"./edit.svg": "./src/images/edit.svg",
	"./edit_16x16.svg": "./src/images/edit_16x16.svg",
	"./editing-finish.svg": "./src/images/editing-finish.svg",
	"./embedsurvey-24x24.svg": "./src/images/embedsurvey-24x24.svg",
	"./error.svg": "./src/images/error.svg",
	"./expand-detail-light_16x16.svg": "./src/images/expand-detail-light_16x16.svg",
	"./expand-detail_16x16.svg": "./src/images/expand-detail_16x16.svg",
	"./expand-panel.svg": "./src/images/expand-panel.svg",
	"./expand-v_16x16.svg": "./src/images/expand-v_16x16.svg",
	"./expand_16x16.svg": "./src/images/expand_16x16.svg",
	"./expandall-24x24.svg": "./src/images/expandall-24x24.svg",
	"./export.svg": "./src/images/export.svg",
	"./expression.svg": "./src/images/expression.svg",
	"./fast-entry.svg": "./src/images/fast-entry.svg",
	"./file.svg": "./src/images/file.svg",
	"./fix.svg": "./src/images/fix.svg",
	"./html.svg": "./src/images/html.svg",
	"./image.svg": "./src/images/image.svg",
	"./imagepicker.svg": "./src/images/imagepicker.svg",
	"./import.svg": "./src/images/import.svg",
	"./invisible-items.svg": "./src/images/invisible-items.svg",
	"./keyboard-dragging.svg": "./src/images/keyboard-dragging.svg",
	"./language.svg": "./src/images/language.svg",
	"./load.svg": "./src/images/load.svg",
	"./logic-24x24.svg": "./src/images/logic-24x24.svg",
	"./logic-collapse.svg": "./src/images/logic-collapse.svg",
	"./logic-expand.svg": "./src/images/logic-expand.svg",
	"./logo.svg": "./src/images/logo.svg",
	"./matrix.svg": "./src/images/matrix.svg",
	"./matrixdropdown.svg": "./src/images/matrixdropdown.svg",
	"./matrixdynamic.svg": "./src/images/matrixdynamic.svg",
	"./multipletext.svg": "./src/images/multipletext.svg",
	"./next_16x16.svg": "./src/images/next_16x16.svg",
	"./panel.svg": "./src/images/panel.svg",
	"./paneldynamic.svg": "./src/images/paneldynamic.svg",
	"./pg-v1/pg-appearance-24x24.svg": "./src/images/pg-v1/pg-appearance-24x24.svg",
	"./pg-v1/pg-background-24x24.svg": "./src/images/pg-v1/pg-background-24x24.svg",
	"./pg-v1/pg-columns-24x24.svg": "./src/images/pg-v1/pg-columns-24x24.svg",
	"./pg-v1/pg-conditions-24x24.svg": "./src/images/pg-v1/pg-conditions-24x24.svg",
	"./pg-v1/pg-data-24x24.svg": "./src/images/pg-v1/pg-data-24x24.svg",
	"./pg-v1/pg-design-24x24.svg": "./src/images/pg-v1/pg-design-24x24.svg",
	"./pg-v1/pg-general-24x24.svg": "./src/images/pg-v1/pg-general-24x24.svg",
	"./pg-v1/pg-header-24x24.svg": "./src/images/pg-v1/pg-header-24x24.svg",
	"./pg-v1/pg-language-24x24.svg": "./src/images/pg-v1/pg-language-24x24.svg",
	"./pg-v1/pg-layout-24x24.svg": "./src/images/pg-v1/pg-layout-24x24.svg",
	"./pg-v1/pg-logo-24x24.svg": "./src/images/pg-v1/pg-logo-24x24.svg",
	"./pg-v1/pg-navigation-24x24.svg": "./src/images/pg-v1/pg-navigation-24x24.svg",
	"./pg-v1/pg-pages-24x24.svg": "./src/images/pg-v1/pg-pages-24x24.svg",
	"./pg-v1/pg-questiondesign-24x24.svg": "./src/images/pg-v1/pg-questiondesign-24x24.svg",
	"./pg-v1/pg-quiz-24x24.svg": "./src/images/pg-v1/pg-quiz-24x24.svg",
	"./pg-v1/pg-rows-24x24.svg": "./src/images/pg-v1/pg-rows-24x24.svg",
	"./pg-v1/pg-specific-24x24.svg": "./src/images/pg-v1/pg-specific-24x24.svg",
	"./pg-v1/pg-thankyyoupage-24x24.svg": "./src/images/pg-v1/pg-thankyyoupage-24x24.svg",
	"./pg-v1/pg-themes-24x24.svg": "./src/images/pg-v1/pg-themes-24x24.svg",
	"./pg-v1/pg-totals-24x24.svg": "./src/images/pg-v1/pg-totals-24x24.svg",
	"./pg-v1/pg-undefined-24x24.svg": "./src/images/pg-v1/pg-undefined-24x24.svg",
	"./pg-v1/pg-validation-24x24.svg": "./src/images/pg-v1/pg-validation-24x24.svg",
	"./preview.svg": "./src/images/preview.svg",
	"./previous_16x16.svg": "./src/images/previous_16x16.svg",
	"./radiogroup.svg": "./src/images/radiogroup.svg",
	"./ranking.svg": "./src/images/ranking.svg",
	"./rating.svg": "./src/images/rating.svg",
	"./redo.svg": "./src/images/redo.svg",
	"./remove_16x16.svg": "./src/images/remove_16x16.svg",
	"./required.svg": "./src/images/required.svg",
	"./reset.svg": "./src/images/reset.svg",
	"./restore_16x16.svg": "./src/images/restore_16x16.svg",
	"./save.svg": "./src/images/save.svg",
	"./select-page.svg": "./src/images/select-page.svg",
	"./settings.svg": "./src/images/settings.svg",
	"./settings_16x16.svg": "./src/images/settings_16x16.svg",
	"./signaturepad.svg": "./src/images/signaturepad.svg",
	"./switch-active_16x16.svg": "./src/images/switch-active_16x16.svg",
	"./switch-inactive_16x16.svg": "./src/images/switch-inactive_16x16.svg",
	"./tagbox.svg": "./src/images/tagbox.svg",
	"./text.svg": "./src/images/text.svg",
	"./theme.svg": "./src/images/theme.svg",
	"./toolbox.svg": "./src/images/toolbox.svg",
	"./undefined-24x24.svg": "./src/images/undefined-24x24.svg",
	"./undo.svg": "./src/images/undo.svg",
	"./visible.svg": "./src/images/visible.svg",
	"./wizard.svg": "./src/images/wizard.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync recursive \\.svg$";